import React, { useState, useRef, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Link, Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import {
  PopupMenu,
  TabsContainer,
  TabItem,
  Drawer
} from 'quantux-ui';
import About from '../about';
import Contact from '../contact';
import CompanyEditProfileDrawer from './company-edit-profile-drawer';
import { blue } from '../../theme';

const tabsTextStyles = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

const AboutCompany = (props) => {
  const [bannerImageUrl, setBannerImageUrl] = useState('');
  const [avatarImageUrl, setAvatarImageUrl] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [userName, setUserName] = useState('');
  const [profileDescription, setProfileDescription] = useState('');
  const [streetAddress1, setStreetAddress1] = useState('');
  const [suite, setSuite] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [fax, setFax] = useState('');
  const [website, setWebsite] = useState('');
  const [isEllipisiMenuOpen, setIsEllipisiMenuOpen] = useState(false);
  // Edit profile drawer
  const [showEditProfileDrawer, setShowEditProfileDrawer] = useState(false);

  // -- Refs
  const popupRef = useRef();
  const tabsContainer = useRef();

  // -- React router history
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const { path, url } = useRouteMatch();

  // -- Effects ---------------------------------------------------------
  useEffect(() => {
    const {
      userName: userNameProp = '',
      displayName: displayNameProp = '',
      avatarImageUrl: avatarImageUrlProp = 'https://quantumtrader.s3.amazonaws.com/defaultAvatar.svg',
      bannerImageUrl: bannerImageUrlProp = 'https://quantumtrader.s3.amazonaws.com/defaultBanner.svg',
      profileDescription: profileDescriptionProp = '',
      email: emailProp = '',
      phone: phoneProp = '',
      fax: faxProp = '',
      mailingAddress: mailingAddressProp = {},
      companyName: companyNameProp = '',
      website: websiteProp = ''
    } = props.companyData;

    console.log(props.companyData.profileDescription);

    const {
      streetAddress1: streetAddressProp = '',
      suite: suiteProp = '',
      city: cityProp = '',
      state: stateProp = '',
      zip: zipProp = ''
    } = mailingAddressProp;

    setBannerImageUrl(bannerImageUrlProp);
    setAvatarImageUrl(avatarImageUrlProp);
    setCompanyName(companyNameProp);
    setDisplayName(displayNameProp);
    setUserName(userNameProp);
    setProfileDescription(profileDescriptionProp);
    setStreetAddress1(streetAddressProp);
    setSuite(suiteProp);
    setCity(cityProp);
    setState(stateProp);
    setZip(zipProp);
    setEmail(emailProp);
    setPhone(phoneProp);
    setFax(faxProp);
    setWebsite(websiteProp);
  }, [props.companyData]);

  // -- Styles ----------------------------------------------------------
  const styles = StyleSheet.create({
    profileBanner: {
      borderBottom: '1px solid transparent'
    },
    profileBannerImg: {
      width: '100%',
      height: 'auto',
      maxHeight: '220px'
    },
    bigUserCardContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid transparent'
    },
    userCard: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      borderRadius: '4px'
    },
    userCardIcon: {
      color: 'white',
      fontSize: '70px'
    },
    userCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px',
      borderRadius: '4px'
    },
    userCardDisplayName: {
      color: blue[500]
    },
    userCardEllipsisMenuBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#60A0E0',
      height: '24px',
      width: '24px',
      borderRadius: '50%',
      color: '#001824',
      position: 'relative'
    },
    popupMenuContainer: {
      background: '#083050',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    popupMenuItem: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0'
    },
    menuItemIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      width: '40px'
    },
    menuItemIcon: {
      fontSize: '20px'
    }
  });

  const handleOnClickEditProfile = () => {
    setShowEditProfileDrawer(true);
  };

  // #region Edit Profile Drawer
  const closeEditProfileDrawer = () => {
    setShowEditProfileDrawer(false);
  };
  // #endregion

  return (
    <div className='p-2'>
      {/* Edit profile drawer */}
      {showEditProfileDrawer &&
        <CompanyEditProfileDrawer
          companyData={props.companyData}
          onClose={() => setShowEditProfileDrawer(false)}
          updateData={() => props.reloadCompanyData()}
        />
      }
      {/* Profile banner */}
      <div className={css(styles.profileBanner)}>
        <img
          className={css(styles.profileBannerImg)}
          src={bannerImageUrl}
          alt='Company banner'
        />
      </div>
      {/* Company card container */}
      <div className={`p-2 ${css(styles.bigUserCardContainer)}`}>
        {/* User card */}
        <div className='fx'>
          <div className={css(styles.userCard)}>
            {!avatarImageUrl
              ? <i className={`fa fa-building-o ${css(styles.userCardIcon)}`} />
              : <img
                className={css(styles.userCardAvatarImg)}
                src={avatarImageUrl}
                alt='Company avatar'
              />
            }
          </div>
          <div className='ml-2'>
            <div>{displayName}</div>
            <div className={css(styles.userCardDisplayName)}>
              {`@${userName}`}
            </div>
          </div>
        </div>
        {/* Ellipsis menu */}
        <div
          ref={popupRef}
          className={css(styles.userCardEllipsisMenuBtn)}
          onClick={() => setIsEllipisiMenuOpen(!isEllipisiMenuOpen)}
        >
          <i className='fa fa-ellipsis-v' />
          <PopupMenu
            top={28}
            right={-1}
            visible={isEllipisiMenuOpen}
            parent={popupRef}
            position="absolute"
            onOutsideClick={() => setIsEllipisiMenuOpen(false)}
          >
            <div className={css(styles.popupMenuContainer)}>
              <div
                className={`m-item ${css(styles.popupMenuItem)}`}
                onClick={handleOnClickEditProfile}
              >
                <div className={css(styles.menuItemIconContainer)}>
                  <i className={`fa fa-pencil ${css(styles.menuItemIcon)}`} />
                </div>
                <div>Edit Profile</div>
              </div>
            </div>
          </PopupMenu>
        </div>
      </div>
      {/* Tabs */}
      <div ref={tabsContainer}>
        <TabsContainer
          dropDownId="d1"
          showPlusIcon={false}
          shiftMethod='availableWidth'
          containerWidth={tabsContainer && tabsContainer.current ? tabsContainer.current.getBoundingClientRect().width : 230}
          otherElementsWidth={320}
          minWidth={230}
          dropDownTop={39}
          dropDownLeft={44}
          dropDownHeaderStyles={{
            minWidth: '170px',
            maxWidth: '370px',
            width: '100%'
          }}
          containerStyles={{
            width: '100%'
          }}
        >
          {/* About Tab */}
          <TabItem
            tabKey="1"
            key='9898'
            parentKey="0111"
            text="About"
            isActive={
              pathname.endsWith('/about') ||
              pathname.endsWith('/profile')
            }
            iconClass='fa fa-info-circle'
            style={{
              paddingRight: '0',
              width: '90px',
              minWidth: '90px',
              maxWidth: '80px'
            }}
            textStyles={tabsTextStyles}
            onActivate={() => {
              history.push(`${url}/about`);
            }}
          >
            <Link
              to={`${url}/about`}
              className={css(
                styles.tabText,
                styles.linkStyles,
                pathname.endsWith('/about') && styles.selectedLink
              )}
            >
              About
            </Link>
          </TabItem>
          {/* Contact  */}
          <TabItem
            tabKey="2"
            key='9899'
            parentKey="0111"
            text="Contact"
            isActive={pathname.endsWith('/contact')}
            iconClass='fa fa-info-circle'
            style={{
              paddingRight: '0',
              width: '100px',
              minWidth: '90px',
              maxWidth: '100px'
            }}
            textStyles={tabsTextStyles}
            onActivate={() => {
              history.push(`${url}/contact`);
            }}
          >
            <Link
              to={`${url}/contact`}
              className={css(
                styles.tabText,
                styles.linkStyles,
                pathname.endsWith('/contact') && styles.selectedLink
              )}
            >
              Contact
            </Link>
          </TabItem>
        </TabsContainer>
        {/* Active tab component */}
        <Switch>
          <Route exact path={path}>
            <About description={profileDescription} />
          </Route>
          <Route path={`${path}/about`}>
            <About description={profileDescription} />
          </Route>
          <Route path={`${path}/contact`}>
            <Contact
              organization={companyName}
              hideName
              mailingAddress={{
                street: streetAddress1,
                suite,
                city,
                state,
                zip
              }}
              email={email}
              mobile={null}
              phone={phone}
              fax={fax}
              profileDescription={profileDescription}
              website={website}
            />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default AboutCompany;
